<div class="dark-mode">
    <div class="row">
        <div class="col-4">
            <div class="card card-bg text-center" style="height: 200px; padding: 30px;">
                <h1 class="d-block text-white" style="font-size: 80px;">
                    {{totalObjectives}}
                </h1>
                <h3 class="d-block text-color-black-normal-50" style="font-size: 18px; font-weight: lighter">Objective to sort through</h3>
            </div>
        </div>
        <div class="col-4">
            <div class="card card-bg text-center" style="height: 200px; padding: 30px">
                <h1 class="d-block text-white" style="font-size: 80px;">
                    {{totalTerms}}
                </h1>
                <h3 class="d-block text-color-black-normal-50" style="font-size: 18px; font-weight: lighter">Terms to Keep Track Of</h3>
            </div>
        </div>
        <div class="col-4">
            <div class="card card-bg text-center" style="height: 200px; padding: 30px">
                <h1 class="d-block text-white" style="font-size: 80px;">
                    {{activities?.length}}
                </h1>
                <h3 class="d-block text-color-black-normal-50" style="font-size: 18px; font-weight: lighter">Activities to manage</h3>
            </div>
        </div>
    </div>

    <div class="row mt-2">
        <div class="col-6">
            <div class="card card-bg mt-3 text-center" style="height: 200px; padding: 30px">
                <h1 class="d-block text-white" style="font-size: 80px">
                    {{restricted}}
                </h1>
                <h3 class="d-block text-color-black-normal-50" style="font-size: 18px; font-weight: lighter">Conditions to Restrict Against</h3>
            </div>
        </div>

        <div class="col-6">
            <div class="card card-bg mt-3 text-center" style="height: 200px; padding: 30px">
                <h1 class="d-block text-white" style="font-size: 80px;">
                    {{totalDomains}}
                </h1>
                <h3 class="d-block text-color-black-normal-50" style="font-size: 18px; font-weight: lighter">Domain Supported</h3>
            </div>
        </div>


    </div>
</div>

